<template>
  <div>
    <div class="d-flex justify-content-between align-items-center">
      <h5 class="mb-0 crew-name">
        <department-icon
          v-if="inDiffDept"
          class="mr-1"
          :department="crewMember.department"
        ></department-icon>
        <truncate-text
          class="font-bold"
          :text="crewMember.full_name"
        ></truncate-text>
      </h5>
      <div class="d-flex">
        <Checkbox
          v-model="formData.use_crew_leader_times"
          label="Use Tech's Time"
          class="whitespace-nowrap mb-0"
        ></Checkbox>
        <divider vertical />
        <div class="remove-action link" @click="removeCrewMember">
          <i class="fas fa-times mr-1"></i>
          <span>Remove</span>
        </div>
      </div>
    </div>
    <component
      :is="actualTimesFormVersion"
      v-if="!formData.use_crew_leader_times"
      class="mt-2"
      :appointment-status="appointment.status"
      :name="timesFormName"
      :accepted-time="formData.accepted_time"
      :dispatch-time="formData.dispatch_time"
      :arrival-time="formData.arrival_time"
      :departure-time="formData.departure_time"
      :scheduled-time="appointment.scheduled_time"
      :data-vv-as="timesFormName"
      :appt-pre-work-enabled="appointment.pre_work_enabled"
      @change="handleTimeChange"
    />
    <divider class="full-width member-divider"></divider>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { getProperty } from "@/lib/helpers.js";

import Checkbox from "@/components/Checkbox.vue";
import Divider from "@/components/Divider.vue";
import TruncateText from "@/components/TruncateText.vue";
import ActualTimesFormV2 from "@/EditAppointmentModal/forms/ActualTimesFormV2.vue";
import useVuelidate from "@vuelidate/core";
import DepartmentIcon from "../components/DepartmentIcon.vue";

export default {
  components: {
    ActualTimesFormV2,
    Checkbox,
    Divider,
    DepartmentIcon,
    TruncateText
  },
  props: {
    crewMember: {
      type: Object,
      default: () => ({})
    },
    appointment: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ["change", "remove-crew-member"],
  setup() {
    return {
      v$: useVuelidate()
    };
  },
  data() {
    return {
      formData: {
        use_crew_leader_times: this.crewMember.use_crew_leader_times,
        accepted_time: this.crewMember.accepted_time,
        dispatch_time: this.crewMember.dispatch_time,
        arrival_time: this.crewMember.arrival_time,
        departure_time: this.crewMember.departure_time
      }
    };
  },
  computed: {
    ...mapGetters(["featureEnabledForTenant"]),
    ...mapState({
      inDiffDept({ job }) {
        return (
          getProperty(job.department, "id") !==
          getProperty(this.crewMember.department, "id")
        );
      }
    }),
    timesFormName() {
      return `crew-${this.$vnode.key}`;
    },
    actualTimesFormVersion() {
      return ActualTimesFormV2;
    }
  },
  watch: {
    "formData.use_crew_leader_times": function (newValue) {
      if (!newValue) {
        const { arrival_time, dispatch_time, departure_time } =
          this.appointment;
        this.formData = {
          ...this.formData,
          arrival_time,
          dispatch_time,
          departure_time
        };
      }
      this.$emit("change", this.crewPayload());
    }
  },
  methods: {
    removeCrewMember() {
      this.$emit("remove-crew-member", this.crewMember);
    },
    handleTimeChange(name, value) {
      this.formData[name] = value;
      this.$emit("change", this.crewPayload());
    },
    crewPayload() {
      return {
        ...this.crewMember,
        ...this.formData
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.tech-pill {
  background-color: var(--white);
  border-radius: 25px;
  border: 1px solid var(--secondary-color);
  padding: 4px 8px;
  display: inline-block;
  margin-right: 10px;
}

.remove-action {
  display: flex;
  align-items: center;
  text-decoration: none;
  font-weight: bold;
  i {
    font-size: 1rem;
    position: relative;
    bottom: -1px;
  }
}

.member-divider {
  margin: 20px 0;
}

.crew-name {
  display: flex;
  align-items: center;
  width: 60%;
}
</style>
